import React from "react";
import { total, usd, type ExecutiveTransaction } from "../../data/executiveOverview";

const regionRows = [
  {
    region: "North America",
    spend: "$1180M",
    volume: 4820,
    fill: 1,
    risk: "Low",
    badgeBg: "#D1FADF",
    badgeColor: "#027A48",
    barColor: "#492750",
    badgeText: "Low",
  },
  {
    region: "EMEA",
    spend: "$842M",
    volume: 3940,
    fill: 0.7,
    risk: "Medium",
    badgeBg: "#FEF7C3",
    badgeColor: "#B54708",
    barColor: "#492750",
    badgeText: "Medium",
  },
  {
    region: "APAC",
    spend: "$598M",
    volume: 2618,
    fill: 0.5,
    risk: "High",
    badgeBg: "#FEE4E2",
    badgeColor: "#B42318",
    barColor: "#492750",
    badgeText: "High",
  },
  {
    region: "LATAM",
    spend: "$142M",
    volume: 712,
    fill: 0.2,
    risk: "Medium",
    badgeBg: "#FEF7C3",
    badgeColor: "#B54708",
    barColor: "#492750",
    badgeText: "Medium",
  },
  {
    region: "Africa",
    spend: "$78M",
    volume: 391,
    fill: 0.1,
    risk: "Medium",
    badgeBg: "#FEF7C3",
    badgeColor: "#B54708",
    barColor: "#492750",
    badgeText: "Medium",
  },
];

export function SpendTrendAnalysis({ rows }: { rows?: ExecutiveTransaction[] }) {
  const regions = rows ? Array.from(new Set(rows.map((row) => row.Geography))).map((region) => {
    const members = rows.filter((row) => row.Geography === region);
    const spend = total(members, "Spend_Amount_USD");
    const exposure = total(members.filter((row) => row.Maverick_Spend_Flag === "Yes"), "Spend_Amount_USD");
    const badgeText = exposure / (spend || 1) > 0.2 ? "High" : exposure / (spend || 1) > 0.1 ? "Medium" : "Low";
    return { region, spend: usd(spend), volume: members.length, amount: spend, badgeText, barColor: "#492750" };
  }).sort((first, second) => second.amount - first.amount).map((region, _, all) => ({ ...region, fill: region.amount / (all[0]?.amount || 1) })) : regionRows;
  return (
    <div className="chart-panel trend-panel">
      <div className="trend-panel__title">Spend Trend Analysis</div>
      <div className="trend-panel__desc">{rows ? "Spend and transaction volume by geography." : "Monthly spend by direct, indirect and contracted ($M)."}</div>
      <div className="trend-panel__divider" />
      <div className="trend-panel__list">
        {regions.map((row) => (
          <div key={row.region} className="trend-panel__row">
            <div className="trend-panel__region">{row.region}</div>
            <div className="trend-panel__bar-wrap">
              <div className="trend-panel__bar" style={{ width: `${row.fill * 100}%`, background: row.barColor }} />
            </div>
            <div className="trend-panel__spend">{row.spend}</div>
            <div className="trend-panel__volume">{row.volume}</div>
            <span className={`trend-badge trend-badge--${row.badgeText.toLowerCase()}`}>{row.badgeText}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
